import { render, staticRenderFns } from "./CodaSplitRows.vue?vue&type=template&id=79a26007"
import script from "./CodaSplitRows.vue?vue&type=script&lang=ts"
export * from "./CodaSplitRows.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79a26007')) {
      api.createRecord('79a26007', component.options)
    } else {
      api.reload('79a26007', component.options)
    }
    module.hot.accept("./CodaSplitRows.vue?vue&type=template&id=79a26007", function () {
      api.rerender('79a26007', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bank/CodaSplitRows.vue"
export default component.exports